const NotFound = () => import('@/pages/NotFound');

export default {
  path: '*', 
  component: NotFound
};